<template>
  <div>
    <div class="row">
      <div class="col-sm-2">
        <div>
          <img :src="'/images/bannerlayout.png'" alt="" />
        </div>
      </div>
      <div class="col-sm-10">
        <div>
          <h2 style="font-weight: 600; margin-bottom: 0.5rem !important">
            Banner Image
          </h2>
          <small style="font-size: 80% !important"
            >Choose an image that will be displayed at the top of your
            page</small
          >
        </div>
      </div>
    </div>
    <form ref="form" data-url="/admin/company/profile/edit-banner" class="mt-4" enctype="multipart/form-data">
      <div class="form-group row mb-0">
        <!-- <label class="col-sm-2 mb-sm-0">
          {{ $t("upload_with_preview") }}
        </label> -->
        <div class="col-sm-8">
          <app-input
            type="custom-file-upload"
            :label="$t('upload_your_file')"
            v-model="inputs.company_banner"
          />
          <small class="text-muted font-italic">
            {{ $t("recommended_custom_file_validation") }}
          </small>
        </div>
      </div>
      <div class="mt-2" v-if="userRole.company_id == inputs.id">
        <app-load-more
                  :preloader="preloader"
                  :label="$t('save')"
                  type="submit"
                  class-name="btn btn-primary text-center"
                  @submit="submit"
                />
      </div>
    </form>
  </div>
</template>
<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
export default {
  mixins: [FormMixin],
  data() {
    return {
      inputs: {
        company_banner:this.$store.state.userCompanyProfile.dataProfile.company.banner,
        id:this.$store.state.userCompanyProfile.dataProfile.company.id,
      },
    };
  },
  computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
  },
  methods: {
      submit()
      {

        let formData = new FormData;
          for (const [key, value] of Object.entries(this.inputs)) {
              formData.append(key, value);
          }
          
          this.save(formData);    
      },
      afterSuccess(res) {
      this.$toastr.s(res.data.message);
      },
      // afterFinalResponse() {
      //   this.preloader = false;
      // },
      afterError(res) {
        this.$toastr.e(res.data.message);
      },
    }
};
</script>
